export { default as Videos } from "./Videos";
export { default as Quotes } from "./Quotes";
export { default as Graphics } from "./Graphics";
export { default as Movies } from "./Movies";
export { default as News } from "./News";
export { default as MyAccount } from "./MyAccount";
export { default as Indicators } from "./Indicators";
